import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ReportPropertyDetailConstant } from '../../residential-property/residential-property-detail.constant';
import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';


@Component({
  selector: 'app-residential-rentalincome-assessement',
  templateUrl: './residential-rentalincome-assessement.component.html',
  styleUrls: ['./residential-rentalincome-assessement.component.scss']
})
export class ResidentialRentalincomeAssessementComponent implements OnChanges {
  @Output() isEmpatyCheck: any = new EventEmitter();
  @Input() propertyInfo: any;

  rentalIncomeCountLoading = false;
  rentalIncomeCountData = [];
  rentalIncomeCount = 0;

  rentalIncomeAreaLoading = false;
  rentalIncomeAreaData = [];
  rentalIncomeAreaCount = 0;

  rentalIncomeCountColumns  = ReportPropertyDetailConstant.rentalIncomeCount;
  // rentalIncomeAreaColumns  = ReportPropertyDetailConstant.rentalIncomeArea;
  placeCode: any;


  constructor(public reportPropertyDetailService: ReportPropertyDetailService,
    private reportService: ReportService, private sharedService: SharedService
  ){
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    //Update Column Monthly/Annual
    if (this.sharedService.priceCalculation$() === this.sharedService.priceYearly) {
      // Residential Rental Income Assessment Table one 
      const columnsToUpdate = [
        { header: 'rental_price', columnName: 'reports.yearly_rentals' }
      ];
      columnsToUpdate.forEach(column => {
        const targetColumn = this.rentalIncomeCountColumns.find(x => x.header === column.header);
        if (targetColumn) {
          targetColumn.columnName = column.columnName;
        }
      });
    }
  }

  ngOnChanges(): void {
    this.sharedService.language$.subscribe({
      next : (res: any) => {
        this.getRentalIncomeCount();
      },
      error : (err:any) => { }
    })
  }

  getRentalIncomeCount() {
    this.rentalIncomeCountLoading = true;
    this.reportPropertyDetailService.getRentalIncomeCountReport(this.reportPropertyDetailService.rentalIncomeCountPayload).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.isEmpatyCheck.emit(true);
            res.data.map((el:any)=>{
              Object.keys(el).map((e:any)=>{
                if(['rental_price', 'rental_rate'].includes(e)){
                  el[e] = this.reportService.rangeToNumberFor(el[e]);
                }
              })
            })
            this.rentalIncomeCountData = res.data;
              if(this.reportPropertyDetailService.rentalIncomeCountPayload.pageNumber == 0){
              this.rentalIncomeCount = res.count;
            }
            
          } else {
            this.isEmpatyCheck.emit(false);
            this.rentalIncomeCountData = [];
            this.rentalIncomeCount = 0;
          }
          this.rentalIncomeCountLoading = false;
        },
        error:()=>{
           this.isEmpatyCheck.emit(false);
          this.rentalIncomeCountLoading = false;
          this.rentalIncomeCountData = [];
          this.rentalIncomeCount = 0;
         
        }
      }
    )
  }

  // getRentalIncomeArea() {
  //   this.rentalIncomeAreaLoading = true;
  //   this.reportPropertyDetailService.getRentalIncomeAreaReport(this.reportPropertyDetailService.rentalIncomeAreaPayload).subscribe(
  //     {
  //       next: (res: any) => {
  //         if (res.status === 200) {
  //           res.data.map((el:any)=>{
  //             Object.keys(el).map((e:any)=>{
  //               if(['lease_rate'].includes(e)){
  //                 el[e] = this.reportService.rangeToNumberFor(el[e]);
  //               }
  //             })
  //           })
  //          this.rentalIncomeAreaData = res.data;
  //           if(this.reportPropertyDetailService.rentalIncomeAreaPayload.pageNumber == 0){
  //           this.rentalIncomeAreaCount = res.count;
  //          }
            
  //         } else {
  //           this.rentalIncomeAreaData = [];
  //           this.rentalIncomeAreaCount = 0;
  //         }
  //         this.rentalIncomeAreaLoading = false;
  //       },
  //       error:()=>{
  //         this.rentalIncomeAreaLoading = false;
  //         this.rentalIncomeAreaData = [];
  //         this.rentalIncomeAreaCount = 0;
         
  //       }
  //     }
  //   )
  // }

  sortData(event: any, type: number) {
    let sort = {
      column: (event.active == 'ir_lease_rate') ? 'lease_rate': event.active,
      order: event.direction
    }
    // if(type === 1){
      this.reportPropertyDetailService.rentalIncomeCountPayload.pageNumber = 0;
      this.reportPropertyDetailService.rentalIncomeCountPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getRentalIncomeCount();
    // } else {
    //   this.reportPropertyDetailService.rentalIncomeAreaPayload.pageNumber = 0;
    //   this.reportPropertyDetailService.rentalIncomeAreaPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    //   this.getRentalIncomeArea();
    // }
    
  }

  downloadExcel(type:string) {
    this.reportPropertyDetailService.downloadRentalReport(type,'residential',this.propertyInfo?.property_uid, 'd')
  }
}
